// extracted by mini-css-extract-plugin
module.exports = {"skeletonRecord":"SkeletonHistoryRecord_skeletonRecord__bCMnz","icon":"SkeletonHistoryRecord_icon__2ZwqB","skeletonRecordInfo":"SkeletonHistoryRecord_skeletonRecordInfo__1wJLB"};